import {
    SET_DEFAULT_STATE,
    SET_DEFAULT_STATE_SUCCESS,
    SET_DEFAULT_STATE_FAILED,
    SET_DESTINATION,
    SET_COUNTRY,
    SET_TARIFF,
    GET_ROAMING_OPTIONS_SUCCESS,
    GET_ROAMING_OPTIONS_FAILED,
} from './constants';
import {
    Country,
    RoamingOption,
} from './types';

/**
 * sets Default State
 */
export const setDefaultState = () => ({
    type: SET_DEFAULT_STATE,
});
/**
 * setDefaultStateSuccess
 */
export const setDefaultStateSuccess = (countries: Country[]) => ({
    type: SET_DEFAULT_STATE_SUCCESS,
    countries,
});
/**
 * setDefaultStateSuccess
 */
export const setDefaultStateFailed = () => ({
    type: SET_DEFAULT_STATE_FAILED,
});
/**
 * setDestination
 */
export const setDestination = (destination: string) => ({
    type: SET_DESTINATION,
    destination,
});
/**
 * setCountry
 */
export const setCountry = (country: string) => ({
    type: SET_COUNTRY,
    country,
});
/**
 * setTariff
 */
export const setTariff = (tariff: string) => ({
    type: SET_TARIFF,
    tariff,
});
/**
 * setDefaultStateSuccess
 */
export const getRoamingOptionsSuccess = (options: RoamingOption[]) => ({
    type: GET_ROAMING_OPTIONS_SUCCESS,
    options,
});

/**
 * getRoamingOptionsFailed
 */
export const getRoamingOptionsFailed = () => ({
    type: GET_ROAMING_OPTIONS_FAILED,
});
